module.exports = __webpack_public_path__ + "static/img/A-applep.64471e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-applep.png
// module id = 5Msr
// module chunks = 3